import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class CompanyService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('Company');
	}

	loadAll(activeOnly: boolean): Observable<TooBig4Car.Logic.Company[]> {
		return this.myBaseService.loadAll(this.url + '?active=' + (activeOnly ?? true).toString());
	}
	save(tempItem: TooBig4Car.Logic.ObjectBase): Observable<TooBig4Car.Logic.Company> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<TooBig4Car.Logic.Company> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid): Observable<TooBig4Car.Logic.Company> {
		return this.myBaseService.get(id, this.url);
	}
	search(searchTerm: string): Observable<TooBig4Car.Logic.Company[]> {
		return this.myBaseService.post(searchTerm, this.url + '/Search', false);
	}
	getOverallSettings(id: System.Guid): Observable<TooBig4Car.Logic.CompanyOverallSettingsVM> {
		return this.myBaseService.get(id, this.url + '/OverallSettings');
	}
	saveOverallSettings(obj: TooBig4Car.Logic.BillingSettings): Observable<string> {
		return this.myBaseService.post(obj, this.url + '/OverallSettings', true);
	}
	getPaymentSystemData(id: System.Guid): Observable<TooBig4Car.Logic.PaymentSystemSettings> {
		return this.myBaseService.get(id, this.url + '/PaymentSystemSettings');
	}
	savePaymentSystemData(obj: TooBig4Car.Logic.PaymentSystemSettings): Observable<string> {
		return this.myBaseService.post(obj, this.url + '/PaymentSystemSettings', true);
	}
	getTwilio(id: System.Guid): Observable<TooBig4Car.Logic.TwilioSettings> {
		return this.myBaseService.get(id, this.url + '/TwilioSettings');
	}
	saveTwilio(obj: TooBig4Car.Logic.TwilioSettings): Observable<string> {
		return this.myBaseService.post(obj, this.url + '/TwilioSettings', true);
	}
	getIntegrationData(): Observable<TooBig4Car.Logic.IntegrationActivationOverallVM> {
		return this.myBaseService.getPlain(this.url + '/IntegrationSettings', 'Error Loading Integration Data');
	}
	saveIntegrationData(obj: TooBig4Car.Logic.CompanyIntegration): Observable<TooBig4Car.Logic.CompanyIntegration> {
		return this.myBaseService.post(obj, this.url + '/IntegrationSettings', true);
	}
}

